module.exports = __webpack_public_path__ + "img/32.4841a0a8.png";